// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".general-info__label[data-v-317b8854] {\n  font-weight: normal;\n  font-size: 14px;\n  color: #727272;\n}\n.general-info__label_icon[data-v-317b8854] {\n  margin-left: -0.9rem;\n}\n.general-info__info[data-v-317b8854] {\n  font-weight: normal;\n  font-size: 16px;\n  color: #11291b;\n}", ""]);
// Exports
module.exports = exports;
